<template>
    <div class="page-content">
        <div class="card">
            <div class="card-header">
                <h3>Cargue de estructuras para el cliente</h3>
                <app-form-select-input
                    v-if="!isClientUser"
                    label="Cliente"
                    :options="clients"
                    v-model="clientId"
                />
            </div>
            <div class="card-body">
                <div class="card-text">
                    <input
                        type="file"
                        name="file"
                        accept=".xlsx"
                        class="file-input"
                        @change="setFile($event.target.files)"
                    />
                    <span v-if="$v.file.$error" class="field-error"
                        >Debe seleccionar un archivo para cargar</span
                    >
                    <div
                        class="file-info water-4 d-flex flex-column"
                        v-if="!!file"
                    >
                        <div class="d-flex flex-row">
                            <div class="shatter-label">Archivo:</div>
                            <div class="shatter-field">{{ file.name }}</div>
                        </div>
                        <div class="d-flex flex-row">
                            <div class="shatter-label">Tamaño:</div>
                            <div class="shatter-field">
                                {{ Math.round(file.size / 1024) }} kb
                            </div>
                        </div>
                    </div>
                    <app-load-structures-results
                        v-if="!!result.ready"
                        :structures="result.structures"
                        :people="result.people"
                        :vehicles="result.vehicles"
                        :errors="result.errors"
                    />
                </div>
            </div>
            <div class="card-footer">
                <div class="pull-right">
                    <app-loader class="pull-right" v-if="loading"></app-loader>
                    <button class="btn btn-secondary" @click="$router.go(-1)">
                        <i
                            class="fa fa-arrow-left fa-lg"
                            aria-hidden="true"
                        ></i>
                    </button>
                    <button
                        class="btn btn-confirm"
                        :disabled="inProgress"
                        v-if="!loading"
                        @click="loadStructures"
                    >
                        Cargar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import clientsRepository from '../../../repositories/clients.repository'
import Loader from '../../../components/UI/Complements/Loader.vue'
import LoadStructuresResults from './LoadStructuresResults.vue'
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
    components: {
        appLoader: Loader,
        appLoadStructuresResults: LoadStructuresResults,
        appFormSelectInput: FormSelectInput,
    },
    data() {
        return {
            file: '',
            loading: false,
            result: {
                ready: false,
                structures: null,
                people: null,
                vehicles: null,
                errors: null,
            },
            clientId: '',
        }
    },
    validations: {
        file: { required },
    },
    computed: {
        ...mapGetters(['clients', 'client']),
        isClientUser() {
            return this.user.profile.slug === 'cliente-admin' || 
                   this.user.profile.client_side === true;
        },
    },
    methods: {
        setFile(files) {
            this.$v.file.$touch()
            if (files.length > 0) {
                this.file = files[0]
            }
        },
        loadStructures() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return false
            }

            this.$v.$reset()

            if (this.isClientUser && this.client) {
                this.clientId = this.client.id
            }

            // disable load button temporally

            const formData = new FormData()
            formData.append('user_id', this.user.id)
            formData.append('client_id', this.clientId)
            formData.append('file', this.file)

            clientsRepository
                .loadStructures(formData)
                .then(data => {
                    this.loading = false
                    this.file = ''
                    // this.$store.dispatch('loadStructures');
                    this.result.structures = data.structures
                    this.result.people = data.people
                    this.result.vehicles = data.vehicles
                    this.result.errors = data.errors
                    this.result.ready = true

                    toastr.success(
                        'Las estructuras han sido cargadas satisfactoriamente'
                    )
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al cargar las estructuras por favor contacte al administrador'
                    )
                })
        },
    },
    created() {
        this.load('clients')
        
        if (this.isClientUser && this.client) {
            this.clientId = this.client.id
        }
    },
}
</script>
